export default __webpack_public_path__ + "resources/icons/n0-5124.png";